// src/context/NegotiationContext.js
import React, { createContext, useState, useContext } from "react";

// 1️⃣ Create context
const NegotiationContext = createContext();

// 2️⃣ Export provider for wrapping your app
export const NegotiationProvider = ({ children }) => {
  const [negotiationData, setNegotiationData] = useState({pdfUrl: null});

  return (
    <NegotiationContext.Provider value={{ negotiationData, setNegotiationData }}>
      {children}
    </NegotiationContext.Provider>
  );
};

// 3️⃣ Custom hook for easy access
export const useNegotiation = () => useContext(NegotiationContext);
